// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> weidner-apartment-homes-weidner-classic-theme -> lpm-apartments
// Generated: 2026-11-03T21:12:06.750Z
// Counts: 0 design, 28 content, 39 slot group, 1 collection binding, 10 section, 1 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities &amp; Luxuries</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "header.company_name": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Interactive Leasing Map</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "luxurydefinition.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "neighborhoodmap.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>High-Rise Sophistication in the Heart of Downtown <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span>, we’re not just pet-friendly, we LOVE pets and show it by providing a fenced-in pet exercise area, always having treats in the office and hosting frequent Yappy Hours…</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "penthouse.featureList": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Floor-to-ceiling windows</li><li>Panoramic city views</li><li>Expansive glass-paneled balconies</li><li>Gas range and electric oven</li><li>GE Stainless Steel Energy Star appliances</li><li>Granite countertops</li><li>Carmel wood kitchen cabinets with stainless steel pulls</li><li>Driftwood or Nutmeg plank flooring</li><li>Kohler bath fixtures</li><li>White cultured marble vanity top</li><li>Spacious closets, including walk-ins</li><li>In-home laundry with full-size washer and dryer</li><li>Individually controlled heat and air-conditioning</li><li>High-speed internet up to 500mbps and premium TV programming</li></ul>",
    "mappedField": null
  },
  "petpolicy.dogs_restrictions": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Pit Bull &amp; Pit Bull Mixes</li><li>American Pit Bull Terrier</li><li>American Staffordshire Terrier</li><li>Wolf Hybrids</li><li>Doberman Pinscher</li><li>Saint Bernard</li></ul><ul><li>American Bulldog</li><li>Staffordshire Bull Terrier</li><li>German Shepherd</li><li>Chow Chow</li><li>Great Dane</li><li>Akita</li></ul>",
    "mappedField": null
  },
  "retailers.blurb": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Brühaven is Loring Park's go-to spot for craft brews, coffee, and camaraderie, pouring from an open brewhouse inside the building that once housed Lakes &amp; Legends. Our taproom opens early with a full coffee menu and keeps a rotating lineup of house beers, seltzers, and more on tap. Come as you are — friends, families, neighbors, and their puppies are all welcome to pull up a chair and stay a while.</p>",
    "mappedField": null
  },
  "retailers.body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Right downstairs, LPM's first-level retailers put dining and gathering steps from your door: grab breakfast at Eggy's Diner, settle in for a craft pour and coffee at <a href=\"https://bruhaven.com/\" target=\"_blank\" rel=\"noopener noreferrer\"><strong>Brühaven Brewery</strong></a>, or browse Inspire: Global Gifts for Urban Adventurers. Step outside into Loring Park and its greenway, then cross the Irene Hixon Whitney Bridge to the Walker Art Center and the Minneapolis Sculpture Garden, home to the iconic Spoonbridge and Cherry. When it's time for dinner, the neighborhood delivers with P.S. Steak, Café and Bar Lurcat, and contemporary Italian at Zelo, all just minutes away. For a night out, catch live music at the Dakota, a legendary show at First Avenue, or a Broadway touring production at the Orpheum Theatre. Everyday errands are easy too, with Lunds &amp; Byerlys, Kowalski's Markets, and Target all close by. Get to know more of what's nearby on our <a href=\"/neighborhood\">neighborhood page</a>.</p>",
    "mappedField": null
  },
  "retailers.intro": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>You don't have to go far for a good meal or a cold pour. LPM's first-level tenants keep <strong>Bru Haven Brewery</strong>, <strong>Eggy's Diner</strong>, and the <strong>Inspire</strong> gift shop just an elevator ride from your door.</p>",
    "mappedField": null
  },
  "retailers.name": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "Brühaven Brewery",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.qualifying_criteria_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/company/5726763346821120/01a0edf8-50e1-766e-be36-fe17d735f389.pdf"
      }
    }
  },
  "specialofferbanner.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "accessibility-hero.bg_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "amenitieslist.apartmentPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-9c06-730a-8a25-17a122bb6a65.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with large windows overlooking city skyline."
      }
    }
  },
  "amenitieslist.apartmentPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-bd93-74da-ab58-e333cda0c846.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with stainless steel appliances and granite countertops."
      }
    }
  },
  "amenitieslist.apartmentPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-cf37-74ea-982e-3aed9523439a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bedroom with large windows and city view"
      }
    }
  },
  "amenitieslist.apartmentPhoto4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-d8de-7386-89d5-01224f858368.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bathroom with wood vanity, white countertop, toilet, and shower with floral curtain."
      }
    }
  },
  "amenitieslist.communityPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-e320-709d-86aa-2b19e9d30e88.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop pool and hot tub area with lounge chairs and umbrellas, surrounded by apartment buildings."
      }
    }
  },
  "amenitieslist.communityPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-ec37-75d0-b157-d7b36a2f146f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Gym with treadmills, weight machines, and free weights"
      }
    }
  },
  "amenitieslist.communityPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-f129-7799-8ec6-4bbe37e92d5a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern lounge area with sectional sofa, armchairs, coffee tables, and decorative pendant lights."
      }
    }
  },
  "amenitieslist.communityPhoto4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a6-0623-74e3-8125-e9edec758c8e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Billiard table and foosball table in a community lounge with large windows overlooking the city."
      }
    }
  },
  "apply-now-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d29-9377-726c-b023-8087beea14ba.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Person holding and using a smartphone outdoors, focusing on hands and screen."
      }
    }
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "frc-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[1].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[1].image_media.alt_text"
      }
    }
  },
  "interactive-leasing-map-hero.bg_image": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "luxurydefinition.propertygraphic": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6737460151191502/01a03fda-61b9-779c-be9f-156bc55a3327.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "LPM Apartments logo, Loring Park, Minneapolis"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "penthouse.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views."
      }
    }
  },
  "penthouse.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-bd93-74da-ab58-e333cda0c846.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with stainless steel appliances and granite countertops."
      }
    }
  },
  "penthouse.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-cf37-74ea-982e-3aed9523439a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bedroom with large windows and city view"
      }
    }
  },
  "penthouse.photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a6-38be-7063-b134-288d4e16f328.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious balcony with panoramic city views and glass railings."
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d28-a0cd-710f-935b-91b1b1af6ac7.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fluffy dog peacefully resting on a bed with a wooden headboard in a cozy indoor setting."
      }
    }
  },
  "petpolicy.cats_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A content cat resting indoors"
      }
    }
  },
  "petpolicy.dogs_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A friendly puppy sitting on a wooden chair"
      }
    }
  },
  "privacy-policy-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "retailers-hero.bg_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "retailers.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a6-05d3-751d-b861-fb75febff647.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Comfortable seating area with Adirondack chairs and tables on artificial turf with a brewery in the background."
      }
    }
  },
  "retailers.retailer1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a6-05d3-751d-b861-fb75febff647.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Comfortable seating area with Adirondack chairs and tables on artificial turf with a brewery in the background."
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bru Haven Brewery"
      },
      "blurb": {
        "type": "GENERATOR",
        "generatedValue": "A neighborhood brewery right on the first level, with taproom energy and outdoor turf seating you never have to leave the building for."
      }
    }
  },
  "retailers.retailer2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a6-09e7-7633-83b0-406a567f6777.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Eggy's sign"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Eggy's Diner"
      },
      "blurb": {
        "type": "GENERATOR",
        "generatedValue": "Casual diner fare for breakfast, brunch, or a late bite after a night out—all steps from the lobby."
      }
    }
  },
  "retailers.retailer3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-f610-71bc-83e7-503ca0c238cd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior of a retail store with clothing, bags, and decorative items on display."
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Inspire: Global Gifts for Urban Adventurers"
      },
      "blurb": {
        "type": "GENERATOR",
        "generatedValue": "A curated first-level boutique stocked with apparel, accessories, and home decor for the city explorer."
      }
    }
  },
  "reviews-hero.bg_image": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "sitemap-hero.bg_image": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": [
      "ec_fad88fa7a350964a06294c7b",
      "ec_08f738a67b06a2caa5a14539",
      "ec_c454b39e10ee70ee87f95628",
      "ec_a77c599927ad2c06f19ed412",
      "ec_d8711ce0f90682e5bd3178fc",
      "ec_28c20ca72a796be0e65ec07e",
      "ec_876b80cc66454c73b0973c8a",
      "ec_f2329461066e56c0502369aa"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "interactive-leasing-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 10,
      "visible": false
    }
  ]
};

export const styleOverrides = {
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
